import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { useAuth } from "./common/hooks";
import {
  AlertProvider,
  AppThemeProvider,
  AuthProvider,
  DialogProvider,
  LangProvider,
} from "./common/provider";
import { publicRouter } from "./common/router/publicRouter";
import { secureRouter } from "./common/router/secureRouter";
import { configurePaymentService } from "./common/services/paymentService";
import { useFrameBusting } from "./common/hooks/useFrameBusting"
import ApiTester from "./ApiTester";

// Configurer le service de paiement au démarrage
configurePaymentService();

const App = () => {
  useFrameBusting();

  return (
    <LangProvider>
      <AlertProvider>
        <AppThemeProvider>
          <AuthProvider>
            <DialogProvider>
              <RouterProviderSetup />
              <ApiTester />
            </DialogProvider>
          </AuthProvider>
        </AppThemeProvider>
      </AlertProvider>
    </LangProvider>
  );
};

const RouterProviderSetup = () => {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return <RouterProvider router={secureRouter} />;
  }
  return <RouterProvider router={publicRouter} />;
};
export default App;
